import CreateRoom from "./CreateRoom";

export default CreateRoom;
